import { render } from "./destinationContents.vue?vue&type=template&id=6683b992&scoped=true"
import script from "./destinationContents.vue?vue&type=script&lang=js"
export * from "./destinationContents.vue?vue&type=script&lang=js"

import "./destinationContents.vue?vue&type=style&index=0&id=6683b992&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6683b992"]])

export default __exports__